import { ORIENTATION_STATUS } from "../../../src/utilities/general"
function SavedSurveys({drafts, onResume, onDelete}) {
    if (drafts.length === 0) {
        return <div className="text-dark fs-5">No saved reports.</div>
    }

    return (
        <>
            <div className="d-flex flex-column gap-4">
                {drafts.map((draft) => (
                    <div key={draft.id} className="card card-bordered card-px-0">
                        <div className="card-header bg-gray-700 min-h-50px px-4">
                            <h3 className="card-title text-primary m-0 p-0 w-75">{draft.orientee_name}</h3>
                            <div className="card-toolbar p-0 gap-3 w-25 justify-content-end">
                                <button
                                    className="btn btn-icon btn-light-danger btn-sm"
                                    onClick={() => onDelete(draft)}
                                    title="Delete"
                                    disabled={draft.orientation_status_id === ORIENTATION_STATUS.PAUSED}
                                >
                                    <i className="fas fa-trash"></i>
                                </button>
                                <button
                                    className="btn btn-icon btn-light-primary btn-sm"
                                    onClick={() => onResume(draft)}
                                    title="Resume"
                                    disabled={draft.orientation_status_id === ORIENTATION_STATUS.PAUSED}
                                >
                                    <i className="fas fa-external-link-alt"></i>
                                </button>
                            </div>
                        </div>
                        <div className="card-body px-4">
                            <div className="d-flex flex-stack flex-wrap align-items-baseline gap-10">
                                <div className="d-flex flex-column">
                                    <span className="fw-bold">Last Modified</span>
                                    <span className="fs-5">
                                        {new Date(draft.updated_at).toLocaleDateString("en-US", {
                                            month: "short",
                                            day: "2-digit",
                                            year: "numeric",
                                        })}
                                    </span>
                                </div>
                                <div className="d-flex flex-column">
                                    <span className="fw-bold">Progress</span>
                                    <span className="fs-5">
                                        {draft.answered} of {draft.total}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default SavedSurveys
